import { render } from "./Logo.vue?vue&type=template&id=6494804b&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=6494804b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6494804b"
/* hot reload */
if (module.hot) {
  script.__hmrId = "6494804b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6494804b', script)) {
    api.reload('6494804b', script)
  }
  
  module.hot.accept("./Logo.vue?vue&type=template&id=6494804b&scoped=true", () => {
    api.rerender('6494804b', render)
  })

}

script.__file = "src/layout/components/Sidebar/Logo.vue"

export default script